// The station this copy of the app runs: name, company, city and colour (Station Setup).
// Fetched once, before login too, and shared by every screen that shows it.
import { useEffect, useState } from "react";
import api from "@/lib/api";

let cached = null;
let pending = null;

// "#800000" -> the site colour every brand-coloured bar and button uses (index.css --brand)
export function applyBrand(hex) {
  const m = /^#?([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i.exec(hex || "");
  if (!m) return;
  const [r, g, b] = m.slice(1).map((h) => parseInt(h, 16));
  document.documentElement.style.setProperty("--brand", `${r} ${g} ${b}`);
  // the standard buttons and focus rings use --primary (HSL): the same colour
  const [R, G, B] = [r / 255, g / 255, b / 255];
  const max = Math.max(R, G, B), min = Math.min(R, G, B), l = (max + min) / 2, d = max - min;
  const sat = d === 0 ? 0 : d / (1 - Math.abs(2 * l - 1));
  const hue = d === 0 ? 0 : max === R ? 60 * (((G - B) / d) % 6) : max === G ? 60 * ((B - R) / d + 2) : 60 * ((R - G) / d + 4);
  const hsl = `${Math.round((hue + 360) % 360)} ${Math.round(sat * 100)}% ${Math.round(l * 100)}%`;
  document.documentElement.style.setProperty("--primary", hsl);
  document.documentElement.style.setProperty("--ring", hsl);
}

function load() {
  if (!pending) {
    pending = api.get("/site").then(({ data }) => {
      cached = data;
      applyBrand(data.brand_color);
      document.title = `${data.name} - Shift Reconciliation`;
      return data;
    }).catch(() => (pending = null));
  }
  return pending;
}

export function useSite() {
  const [site, setSite] = useState(cached);
  useEffect(() => {
    if (!cached) load().then((d) => d && setSite(d));
  }, []);
  return site || { name: "", operator: "", city: "" };
}
